module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-32.a1c89edf.svg";